import { createSelector } from 'reselect';
import CarditTimelinessAnalysisColumns from '../../containers/CarditTimelinessAnalysisColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.CARDIT_TIMELINESS_ANALYSIS.metadata.generatedOnDateTime;

export const getIsLoading = state => state.reporting.CARDIT_TIMELINESS_ANALYSIS.isLoading;

export const getData = ReportDefinitions.CARDIT_TIMELINESS_ANALYSIS.getDataFunction();

export const getColumns = createSelector(getData, CarditTimelinessAnalysisColumns);
